import { render, staticRenderFns } from "./brandManagement.vue?vue&type=template&id=8a974e6e&scoped=true&"
import script from "./brandManagement.vue?vue&type=script&lang=js&"
export * from "./brandManagement.vue?vue&type=script&lang=js&"
import style0 from "./brandManagement.vue?vue&type=style&index=0&id=8a974e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a974e6e",
  null
  
)

component.options.__file = "brandManagement.vue"
export default component.exports